<template></template>

<script>
  import 'jquery-validation'
  
  export default {
    name: 'RegisterAwardAndHonour',
    mounted() {
      const $form = $('.form')

      /**
       * Init JQuery validation
       */
      $(() => {
        $form.validate({
          ignore: [],
          highlight: function(element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function(label, element) {
            if(element.hasClass('select2-input')) {
              label.insertAfter(element.siblings('span.select2'))
            } else if(element.is(':radio')) {
              label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
            }
            else {
              label.insertAfter(element)
            }

            label.addClass('invalid-feedback')
          },
          rules: {
            award: {
              required: true,
            },
            year: {
              required: true,
            },
            institution: {
              required: true,
            },
          },
          messages: {
            award: {
              required: 'Este campo es requerido.',
            },
            year: {
              required: 'Este campo es requerido.',
            },
            institution: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler(form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')

            form.submit()
          },
        })

        $form.removeClass('invisible')

        $('#btn-cancel').on('click', (e) => {
          e.preventDefault()

          history.back()
        })
      })
    },
  }
</script>
